type LookupValues<Values> = Values[keyof Values];
export const CLOSE_REASON = {
  BUTTON: 'closeButtonClick',
  BACKDROP: 'backdropClick',
  ESCAPE: 'escapeKeyDown'
} as const;

export type CloseReason = LookupValues<typeof CLOSE_REASON>;
export const IGNORED_REASONS: CloseReason[] = [
  CLOSE_REASON.BACKDROP,
  CLOSE_REASON.ESCAPE
];
export type CloseHandler = (event: object, reason: CloseReason) => void;
